import * as React from "react";
import type { SVGProps } from "react";
const SvgWifiOff = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#wifi-off_svg__a)">
      <path
        fill="currentColor"
        d="M1.707.293A1 1 0 0 0 .293 1.707zm20.586 23.414a1 1 0 0 0 1.414-1.414zm-5.134-13.546a1 1 0 0 0-.878 1.798zm1.194 3.152a1 1 0 0 0 1.294-1.526zm-13.994-1.53a1 1 0 0 0 1.282 1.534zm5.98-.637A1 1 0 1 0 10 9.174zm.29-7.093a1 1 0 0 0 .161 1.994zM21.92 9.75a1 1 0 0 0 1.323-1.5zM.757 8.25a1 1 0 1 0 1.324 1.5zm5.729-1.2a1 1 0 1 0-.734-1.86zm1.464 8.245a1 1 0 0 0 1.158 1.63zm6.95 1.63a1 1 0 1 0 1.158-1.63zM12 19a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM.293 1.707l22 22 1.414-1.414-22-22zM16.28 11.96a10 10 0 0 1 2.072 1.354l1.294-1.526a12 12 0 0 0-2.488-1.626zm-10.64 1.358a9.94 9.94 0 0 1 4.698-2.171L10 9.174a11.94 11.94 0 0 0-5.642 2.609zm5.15-7.27a15 15 0 0 1 5.94.719l.632-1.898a17 17 0 0 0-6.733-.815zm5.94.719a15 15 0 0 1 5.187 2.984l1.324-1.5a17 17 0 0 0-5.88-3.382zM2.082 9.749A14.9 14.9 0 0 1 6.487 7.05l-.734-1.86A16.9 16.9 0 0 0 .758 8.25zm7.027 7.176a5 5 0 0 1 2.896-.924v-2a7 7 0 0 0-4.054 1.294zm2.896-.924a5 5 0 0 1 2.896.924l1.158-1.63A7 7 0 0 0 12.005 14zM12 21h.01v-2H12z"
      />
    </g>
    <defs>
      <clipPath id="wifi-off_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgWifiOff;
